import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ShCacheInterceptor } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export abstract class BaseBootstrapSandboxService {
    public isAuthenticated$: Observable<boolean>;

    // Injectors
    protected readonly cacheInterceptor: ShCacheInterceptor = inject(ShCacheInterceptor);

    protected readonly store: Store<any> = inject(Store);

    protected constructor() {
        this.isAuthenticated$ = this.buildIsAuthenticatedStream();
    }

    public abstract clearStore(): void;

    protected abstract buildIsAuthenticatedStream(): Observable<boolean>;
}
